import { motion } from "motion/react"

import { AuroraBackground } from "@repo/ui/components/ui/aurora-background"
import { LogoMark } from "@repo/ui/components/ui/logo"
import { cn } from "@repo/ui/lib/utils"

interface LoadingScreenProps {
  withAnimatedBackground?: boolean
  loadTransitionDuration?: number
}

export function LoadingScreen({
  withAnimatedBackground,
  loadTransitionDuration = 1.5,
}: LoadingScreenProps) {
  if (!withAnimatedBackground) {
    return <LoaderBody loadTransitionDuration={loadTransitionDuration} />
  }

  return (
    <AuroraBackground>
      <LoaderBody
        withAnimatedBackground={true}
        loadTransitionDuration={loadTransitionDuration}
      />
    </AuroraBackground>
  )
}

function LoaderBody({
  withAnimatedBackground,
  loadTransitionDuration,
}: {
  withAnimatedBackground?: boolean
  loadTransitionDuration: number
}) {
  return (
    <motion.div
      className={cn(
        "fixed inset-0 z-50 flex flex-col items-center justify-center",
        { "bg-transparent": withAnimatedBackground },
      )}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex w-full max-w-xs flex-col items-center justify-center space-y-6">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <LogoMark width={200} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="w-full"
        >
          <div className="h-1 w-full overflow-hidden rounded-full bg-white/10">
            <motion.div
              className="h-full bg-primary"
              initial={{ width: "5%" }}
              animate={{ width: "100%" }}
              transition={{ duration: loadTransitionDuration }}
            />
          </div>
        </motion.div>
      </div>
    </motion.div>
  )
}
